'use client'

import { type FC, type ReactNode } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokRedPointsRegistrationStatusWrapperType } from '../../storyblok'
import { useStoryblokServerSideData } from '../../storyblok-server-side-data/context/storyblokServerSideDataContext'

export const StoryblokRedPointsRegistrationStatusWrapperContent: FC<
  StoryblokComponentProps<StoryblokRedPointsRegistrationStatusWrapperType> & {
    children: Awaited<ReactNode>
  }
> = ({ blok, children }) => {
  const { data, error } = useStoryblokServerSideData(blok)

  if (error || !data) {
    return null
  }

  const { visibleFor } = blok

  if (data !== visibleFor) {
    return null
  }

  return children
}
